<template>
    <div :class="[{ textAlignRight: !readOnly && editable, textAlignCenter: readOnly || !editable }, 'visibility-item', 'verticalAlignTop', 'iconContainer']   " 
            @mouseenter="active = isTouch ? active : true" @mouseleave="active = isTouch ? active : false" @click="active = isTouch ? !active : active">
        <div v-if="readOnly || !editable"><i :class="getVisibilityClass()"></i></div>
        <div v-if="!readOnly && editable"><i :class="getVisibilityClass()"></i><i class="fa fa-caret-down"></i></div>
        <div v-if="!readOnly && editable && active" class="openIconContainer">
            <div style="margin-bottom:10px"><i :class="getVisibilityClass()"></i><i class="fa fa-caret-up"></i></div>
            <div class="clearfix chooseIconContainer" @click="item.visibility = 'PRIVATE'; active = false">
                <div class="checkContainer"><i v-if="item.visibility == 'PRIVATE'" class="fa fa-check"></i><span v-else>&nbsp;</span></div>
                <div class="iconInnerContainer"><i class="fa fa-lock"></i></div>
                <div class="textContainer">Privat</div>
            </div>
            <div class="clearfix chooseIconContainer" @click="item.visibility = 'PUBLIC'; active = false">
                <div class="checkContainer"><i v-if="item.visibility == 'PUBLIC'" class="fa fa-check"></i><span v-else>&nbsp;</span></div>
                <div class="iconInnerContainer"><i class="fa fa-globe"></i></div>
                <div class="textContainer">Öffentlich</div>
            </div>
        </div>
    </div>
</template>
<script>
    import Modernizr from 'modernizr';
	export default {
		name: 'profileItemVisibilityEditor',
		props: {
            item: Object,
            readOnly: Boolean
        },
         data: function() {
        	return {
                editable: false,
                active: false,
                isTouch: false
        	}
        },
        created: function() {
            if (Modernizr.touchevents) {
                this.isTouch = true;
            }
            if (this.item.visibility.indexOf('DEACTIVATED') == -1) {
                this.editable = true;
            }
        },
        methods: {
            getVisibilityClass: function() {
                let visibility = this.item.visibility;
                return 'fa ' 
                    + (visibility.indexOf('PUBLIC') != -1 ? 'fa-globe' : 'fa-lock')
                    + (visibility.indexOf('DEACTIVATED') != -1 ? ' brightGrey' : '');
            }
        }
	}
</script>


// WEBPACK FOOTER //
// ProfileItemVisibilityEditor.vue?026e04f6